import React from 'react';

import { useField } from '@atlassian/eoc-form';

import { type FieldConditionProps } from './types';

const FieldCondition = <Value extends any = string, Transform = undefined>({
	when,
	is,
	not,
	transform,
	children,
}: FieldConditionProps<Value, Transform>) => {
	const {
		input: { value },
	} = useField<Value>(when, { subscription: { value: true } });

	let shouldRender: boolean;

	if (is) {
		shouldRender = transform ? transform(value) === is : value === is;
	}

	if (not) {
		shouldRender = transform ? transform(value) !== not : value !== not;
	}

	return <>{shouldRender! ? children : null}</>;
};

export { FieldCondition };
